import { render, staticRenderFns } from "./CreateAccommodationCategory.vue?vue&type=template&id=232dc1e1&"
import script from "./CreateAccommodationCategory.vue?vue&type=script&lang=js&"
export * from "./CreateAccommodationCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateAccommodationCategory.vue"
export default component.exports